import React, { Component } from "react";
import { fire, auth } from "../../../firebase/index";
import LocalizedStrings from "react-localization";

let localizationStrings = new LocalizedStrings({
  en: {
    reply1:
      "No, most airlines or airport operators refuse/forbid to let luggage owner putting sizeable rechargeable battery (e.g. Lithium battery power pack of more than 100Wh) into a luggage during check-in as it may risk of overheating and cause fire hazards. Read more on IATA's 'Lithium Battery Guidance Document,' and International Civil Aviation Organization (ICAO) Technical Instructions on Safe Transport of Dangerous Goods - Classified under UN3091 & UN3481. For more info on Tests & Certifications, ",
    reply2: "click here",
    back: "Back",
  },
  ja: {
    reply1:
      "いいえ、ほとんどの航空会社または空港運営者は、過熱して火災の危険を引き起こす可能性があるため、チェックイン時に荷物の所有者が大きな充電式バッテリー (例: 100Wh を超えるリチウム電池パワーパック) を荷物に入れることを拒否または禁止しています。 IATA の「リチウム電池ガイダンス文書」および危険物の安全な輸送に関する国際民間航空機関 (ICAO) の技術指示 - UN3091 および UN3481 に分類されているものの詳細をご覧ください。テストと認定の詳細については、",
    reply2: "ここをクリック",
    back: "戻る",
  },
  es: {
    reply1:
      "No, la mayoría de las aerolíneas u operadores de aeropuertos se niegan o prohíben que el propietario del equipaje coloque una batería recargable de gran tamaño (por ejemplo, una batería de litio de más de 100 Wh) en el equipaje durante el check-in, ya que puede existir riesgo de sobrecalentamiento y riesgo de incendio. Lea más sobre el 'Documento de orientación sobre baterías de litio' de la IATA y las Instrucciones técnicas de la Organización de Aviación Civil Internacional (OACI) sobre el transporte seguro de mercancías peligrosas, clasificadas según UN3091 y UN3481. Para obtener más información sobre pruebas y certificaciones, ",
    reply2: "haga clic aquí",
    back: "Atrás",
  },
});

class Q7_component extends Component {
  constructor(props) {
    super(props);

    this.state = {
      triggerValue: "0",
      clicked: false,
      language: "en",
    };
  }

  componentDidMount() {
    if (auth.currentUser !== null) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .on("value", this._langCb = (snapshot) => {
          localizationStrings.setLanguage(snapshot.val());
          this.setState({ language: snapshot.val() });
        });
    }
  }

  handleButtonClick2 = () => {
    if (!this.state.clicked) {
      this.setState({ triggerValue: "cancel", clicked: true }, () => {
        this.props.triggerNextStep({
          value: "cancel",
          trigger: "cancel",
        });
      });
    }
  };

  componentWillUnmount() {
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    const buttonStyle = {
      marginTop: "10px",
      width: "215px",
      backgroundColor: "#FFC500",
      color: "black",
      borderRadius: "25px",
      textAlign: "center",
      padding: "10px 10px",
      cursor: "pointer",
      transition: "background-color 0.3s",
      border: "none",
    };

    const buttonHoverStyle = {
      color: "white",
      backgroundColor: "#EF6C00",
    };

    const { triggerValue, clicked } = this.state;

    return (
      <div>
        {localizationStrings.reply1}
        <a
          href="http://www.egeetouch.com/support/certificates"
          target="_blank"
          style={{ textDecoration: "underline", color: "black" }}
        >
          {localizationStrings.reply2}
        </a>
        {this.state.language === "ja" ? "。" : "."}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            margin: "12px 0",
          }}
        >
          <button
            style={{
              ...buttonStyle,
              ...(triggerValue === "cancel" && buttonHoverStyle),
            }}
            onMouseEnter={() => this.setState({ isButtonHovered: true })}
            onMouseLeave={() => this.setState({ isButtonHovered: false })}
            onClick={this.handleButtonClick2}
            disabled={clicked}
          >
            {localizationStrings.back}
          </button>
        </div>
      </div>
    );
  }
}

export default Q7_component;
